import * as moment from 'moment';
import 'moment/locale/it';

const enFormMode = {
  VISUALIZZAZIONE: 1,
  INSERIMENTO: 2,
  MODIFICA: 3,
};

const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

const kebab = str => {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const sanitizeFilename = str => {
  return str.replace(/[^a-z0-9]/gi, '_').toLowerCase();
};

const toggleFullScreen = () => {
  let doc = window.document;
  let docEl = doc.documentElement;

  let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
  let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

  if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    requestFullScreen.call(docEl);
  } else {
    cancelFullScreen.call(doc);
  }
};

const riduciTesto = (parole, dim) => {
  if (!parole || parole.length < dim) {
    return parole;
  }
  return parole.substring(0, dim - 3) + '...';
};

const formattaData = date => {
  if (!date) {
    return null;
  }
  return moment(date).format('DD/MM/YYYY');
};

const formattaDataOra = date => {
  if (!date) {
    return null;
  }
  return moment(date).format('DD/MM/YYYY HH:mm');
};

const formattaDataOraFile = date => {
  if (!date) {
    return null;
  }
  return moment(date).format('YYYYMMDDHH:mm');
};

const parseDate = date => {
  if (!date) return null;
  const validFormat = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g;
  if (validFormat.test(date)) {
    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  } else {
    return null;
  }
  /*
  new Date().toISOString();
  // return moment(date).parseDate();
  return moment(date).format('YYYY-MM-DD');
   */
};

const getMonthName = date => {
  if (!date) {
    return null;
  }
  return moment(date).format('MMMM');
};

// individua il tipo di immagine dalla stringa in base64
const guessImageMime = data => {
  if (data.id && data.blobImage) {
    if (data.blobImage.charAt(0) == '/') {
      return 'image/jpeg';
    } else if (data.blobImage.charAt(0) == 'R') {
      return 'image/gif';
    } else if (data.blobImage.charAt(0) == 'i') {
      return 'image/png';
    }
  }
  return 'image/png';
};

const sortArrayByKey = (arr, key) => {
  arr.sort(function (a, b) {
    const textA = a[key].toLowerCase();
    const textB = b[key].toLowerCase();
    if (textA < textB) return -1;
    if (textA > textB) return 1;
    return 0;
  });
};

export default {
  randomElement,
  toggleFullScreen,
  kebab,
  sanitizeFilename,
  riduciTesto,
  formattaData,
  formattaDataOra,
  parseDate,
  getMonthName,
  guessImageMime,
  sortArrayByKey,
  enFormMode,
};